import { useEffect, useState } from 'react'
import { useTokenAuth, type TokenSubscription } from '../../providers/auth/TokenAuthContext'
import { type Audience } from '../../providers/constants'

/**
 * Hook for getting a single token for a specific audience.
 * This is a Phase 3 compatibility wrapper for Phase 4's TokenAuth.
 *
 * @param audience - The audience to get the token for
 * @returns The token string or empty string if not available
 */
export const useAuthTokenWithAudience = (audience: Audience, isEmbedded?: boolean): string => {
  const [token, setToken] = useState<string>('')
  const { subscribeToToken, unsubscribeFromToken } = useTokenAuth({ isEmbedded: isEmbedded })

  useEffect(() => {
    const subscription: TokenSubscription = {
      audience,
      callback: (newToken: string) => {
        setToken(newToken)
      },
    }

    subscribeToToken(subscription)

    return () => {
      unsubscribeFromToken(subscription)
    }
  }, [audience, subscribeToToken, unsubscribeFromToken])

  return token
}
